import { DataResult, State } from '@progress/kendo-data-query';
import { useEffect, useState } from 'react';
import { useQuery, UseQueryOptions } from 'react-query';

interface UseKendoGridReactQueryProps {
    transform?: (data: any) => any;
    query: {
        queryKey: any[];
        queryFn: (gridState: State, ...args: any) => Promise<any>;
        queryOptions?: UseQueryOptions<any>;
    };
}

const useKendoGridReactQuery = ({
    transform,
    query: { queryKey, queryFn, queryOptions },
}: UseKendoGridReactQueryProps) => {
    const [gridState, setGridState] = useState<State>({
        take: 50,
        skip: 0,
    });
    const [gridResult, setGridResult] = useState<DataResult>({
        data: [],
        total: 0,
    });

    const queryFnArgs = typeof queryKey === 'string' ? [] : queryKey.slice(1);
    // Next line => another possible solution
    // const gridQueryKey = typeof queryKey === 'string' ? [queryKey, gridState] : [...queryKey, gridState];
    //@ts-ignore
    const gridQuery = useQuery(queryKey, () => queryFn(gridState, ...queryFnArgs), {
        onSuccess: (data: any[]) => changeGridResult(data),
        ...queryOptions,
    });

    useEffect(() => {
        if((gridQuery as any)?.data?.data?.length === 0){
            setGridState({
                take: 50,
                skip: 0,
            })
        }
        if (gridQuery.data) {
            setGridResult(updateGridResult(gridQuery.data, transform));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [gridQuery.data]);

    const changeGridResult = (result: any[] | DataResult, runTransform = false) => {
        if (runTransform) {
            setGridResult(updateGridResult(result, transform));
        } else {
            setGridResult(updateGridResult(result));
        }
    };

    return { gridState, gridResult, setGridState, changeGridResult, gridQuery };
};

export default useKendoGridReactQuery;

const updateGridResult = (result: any[] | DataResult, transform?: (data: any) => any) => {
    if (isDataResult(result))
    {
        return {
            data: transform ? result.data?.map((item) => transform(item)) : result.data,
            total: result.total,
        } as DataResult
    }

    return {
        data: transform ? result.map((item) => transform(item)) : result,
        total: result.length,
    };
};
const isDataResult = (data: any[] | DataResult): data is DataResult => {
    return (data as DataResult).data !== undefined;
}
